import React, { useContext } from 'react';
import {
  Modal, Box, Typography, Theme,
} from 'vindi-ds-components';
import { AdminContext } from '@contexts/admin_context';
import image from '@assets/images/admin/reports/pablita-uploading 1.svg';

function NotificationModal() {
  const { currentUserEmail } = useContext(AdminContext);
  const modalRef = React.useRef(null);

  function handleOpenModal() {
    modalRef.current.open();
  }

  return (
    <>
      <button type='button' className='hidden' onClick={handleOpenModal} id='btn-modal-open'>CLIQUE AQUI </button>
      <Modal ref={modalRef} title='Quase lá...'>
        <Box display='flex' justifyContent='center'>
          <Box component='img' width={320} height={182} src={image} alt='barra_de_carregamento' />
        </Box>
        <Theme>
          <Typography align='center' variant='body1' weight='bold'>
            Dentro de alguns minutos o relatório estará no seu email
          </Typography>

          <Typography align='center' variant='body2' color='neutral.500'>
            ({currentUserEmail})
          </Typography>
        </Theme>
      </Modal>
    </>
  );
}

export default NotificationModal;
